/**
 * An attachment is renderable once its bytes are on the CDN.
 *
 * `contentUri` is NOT a signal — the platform writes the predicted CDN url at
 * upload-init, so a message sent while the upload is still in flight already
 * carries one. `uploaded` is: it starts `false` at init and flips on
 * `uploads/final`.
 *
 * `fileSize > 0` stays as the first clause because it is the older, broader
 * signal: legacy V4 rows, and uploads whose server-side size poll timed out,
 * are real files that a size-only check would hide.
 */
export function isAttachmentUploaded(attachment: {
  fileSize?: number | null;
  uploaded?: boolean | null;
}): boolean {
  return Number(attachment?.fileSize) > 0 || attachment?.uploaded === true;
}
